export default {
  labels: {
    google_place: 'Google-sted',
    menu_import: 'Menuimport',
    live: 'Live',
    setting_up: 'Under opsætning',
  },
  buttons: {
    confirm: 'Bekræft',
    cancel: 'Annuller',
    continue_setup: 'Fortsæt opsætning',
  },
  delete_confirmation: 'Er du sikker?',
};
